import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Btn from '../../components/Buttons/Btn';
import { getLocalizedHelpCenterMeta } from './localization';
import HelpCenterModal from './HelpCenterModal';
import { getHelpCenterContentBySlug } from './registry';
import { HelpCenterTriggerRenderProps } from './types';
import * as s from './styles';

type Props = {
  slug: string;
  buttonText?: string;
  maximized?: boolean;
  renderTrigger?: (props: HelpCenterTriggerRenderProps) => ReactNode;
};

const HelpCenterTrigger: React.FC<Props> = ({
  slug,
  buttonText,
  maximized = false,
  renderTrigger,
}) => {
  const { i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const contentDefinition = getHelpCenterContentBySlug(slug, 'modal');

  if (!contentDefinition) return null;

  const open = () => setShowModal(true);
  const close = () => setShowModal(false);
  const title = getLocalizedHelpCenterMeta(
    contentDefinition,
    i18n.resolvedLanguage ?? i18n.language,
  ).title;

  return (
    <>
      {renderTrigger ? (
        <>{renderTrigger({ open, title })}</>
      ) : (
        <s.InlineButtonWrapper>
          <Btn text={buttonText ?? title} onClick={open} />
        </s.InlineButtonWrapper>
      )}

      <HelpCenterModal
        showModal={showModal}
        closeModal={close}
        slug={slug}
        maximized={maximized}
      />
    </>
  );
};

HelpCenterTrigger.defaultProps = {
  buttonText: undefined,
  maximized: false,
  renderTrigger: undefined,
};

export default HelpCenterTrigger;
